/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class EmailService extends HttpHandlerService {

        constructor($http: ng.IHttpService) {
            super($http);
        }

        public getUserEmailNotifications(): ng.IPromise<Wars.Domain.Model.Dtos.UserEmailNotificationDto[]> {
            var params: any = {};
            this.handlerUrl = "api/Email/UserEmailNotifications";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.UserEmailNotificationDto[]) => {
                    return result;
                });
        }

        public getAllEmailConfigurationApplicableForCurrentUser(): ng.IPromise<Wars.Domain.Model.Dtos.EmailConfigurationDto[]> {
            var params: any = {};
            this.handlerUrl = "api/Email/EmailConfigurations";
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.EmailConfigurationDto[]) => {
                    return result;
                });
        }

        public createUserEmailNotification(userEmailConfiguration: any) {
            var params = userEmailConfiguration;
            this.handlerUrl = "api/Email/UserEmailNotification/CreateUserEmailNotification";
            return this.usePostHandler(params);
        }

        public deleteUserEmailNotification(userEmailConfiguration: any) {
            var params = userEmailConfiguration;
            this.handlerUrl = "api/Email/UserEmailNotification/Delete";
            return this.usePostHandler(params);
        }
        
        public getEmails(search: any): ng.IPromise<Wars.Domain.Model.Dtos.EmailDto[]> {
            search.createDateBegin = search.createDateBegin !== null && search.createDateBegin !== undefined ? search.createDateBegin : '';
            search.createDateEnd = search.createDateEnd !== null && search.createDateEnd !== undefined ? search.createDateEnd : '';
            var params: any = {};
            this.handlerUrl = "api/Email/UserEmail" +
                "?createDateBegin=" + search.createDateBegin +
                "&createDateEnd=" + search.createDateEnd +
                "&subject=" + search.subject +
                "&body=" + search.body +
                "&processName=" + search.processName;
            return this.useGetHandler(params).then(
                (result: Wars.Domain.Model.Dtos.EmailDto[]) => {
                    return result;
                });
        }

        public updateViewedNotifications(emailNotifications: any) {
            var params = emailNotifications;
            this.handlerUrl = "api/Email/UserEmail/UpdateViewedNotifications";
            return this.usePostHandler(params);
        }

        public getEmailNotificationCount() : ng.IPromise<number>{
            var params: any = {};
            this.handlerUrl = "api/Email/UserEmail/GetEmailNotificationCount";
            return this.useGetHandler(params).then(
                (result: number) => {
                    return result;
                });
        }
        
    }
}

warsApp.registerService('EmailService', ['$http']);